import styled from "styled-components";

export const MemberHandlersStyle = styled.div`
    .anticon {
        color: #A0C63D;
        cursor: pointer;
    }
`;
